export function setLogoutByManager(data={}) {
    return {
      type: 'SET_LOGOUT_BY_MANAGER',
      payload: data,
    }
}

export function resetLogoutByManager() {
  return {
    type: 'RESET_LOGOUT_BY_MANAGER',
    payload: {},
  }
}
  